export const getCategoryOptions = (t) => [
    { value: 'semental', label: t('admin.animal.category_semental') },
    { value: 'vaca', label: t('admin.animal.category_vaca') },
    { value: 'novilla', label: t('admin.animal.category_novilla') },
    { value: 'novillo', label: t('admin.animal.category_novillo') },
    { value: 'ternero_cria', label: t('admin.animal.category_ternero_cria') },
    { value: 'ternero', label: t('admin.animal.category_ternero') }
]